module.exports = __webpack_public_path__ + "img/y- (16).1a9a9a07.png";